module.exports = {
  isHeadwayTail: 'Đầu và đuôi',
  containerLoadType: 'Loại delegate',
  transportType: 'Loại vận chuyển',
  fullHalf: 'Toàn bộ/nửa',
  transportLine: 'Đường bay',
  ETD: 'Ngày vận chuyển',
  ETA: 'Ngày đến',
  ATD: 'Ngày giao hàng thực tế',
  ETD2: 'Ngày giao hàng (ETD)',
  ETA2: 'Ngày đến (ETA)',
  ATD2: 'Ngày giao hàng thực tế (ATD)',
  ATA2: 'Ngày đến thực tế (ATA)',
  departureStation: 'Trạm khởi hành',
  departureStationRe: 'Ga xuất phát (đường sắt)',
  transferStation: 'Trạm trung chuyển',
  transitStation: 'Trạm trung chuyển',
  destinationStation: 'Trạm đích',
  destinationStationRe: 'Ga đích (đường sắt)',
  destinationCountry: 'Quốc gia đích',
  portAgent: 'Đại lý cảng',
  forwardingAgent: 'Đại lý vận chuyển',
  paymentMethod: 'Phương thức thanh toán',
  mbl: 'Số vận đơn',
  vessel: 'Xe đưa đón',
  voyageFlight: 'Loại xe',
  isDiffPlacesCollaborate: 'Hợp tác ngoại vi',
  loadingPlaceCompany: 'Loading Địa điểm Công ty',
  signBillPlaceCompany: 'Công ty ký tên',
  isFullShipment: 'Vận chuyển toàn bộ',
  dischargePortCompany: 'Công ty cảng dỡ hàng',
  destinationPortCompany: 'Công ty cảng đích',
  overseaOp: 'Dịch vụ khách hàng nước ngoài',
  planner: 'Trang chủ',
  plannerOffice: 'Lộ trình công ty',
  plannerDepartment: 'Lộ trình',
  batchVessel: 'Chuyển hàng loạt',
  Query: 'Yêu cầu',
  BuyContainer: 'Mua hộp',
  CallContainer: 'Điều container',
  SellContainer: 'Hộp bán hàng',
  RentContainer: 'Thuê hộp',
  ClearContainerLog: 'Xóa lịch sử điều container',
  ReturnBox: 'Trả container',
  Edit: 'Chỉnh sửa',
  Delete: 'Xoá',
  OrderNo: 'Số thứ tự',
  OrderNo2: 'Mã đơn hàng',
  JobNo2: 'Mã nghiệp vụ',
  ConsignationCompany: 'Khách hàng ủy thác',
  BoxOwner: 'Chủ container/người bán',
  BoxOwner3: 'Chủ container',
  BoxOwner2: 'Bên bán',
  Buyer2: 'Bên mua',
  Buyer: 'Người mua',
  OrderType: 'Loại lệnh',
  ContainerStatus: 'Trạng thái hộp',
  ContainerType: 'Loại container',
  Amount: 'Số lượng',
  WhetherSettlement: 'Có thanh toán hay không',
  SettlingTime: 'Ngày giải quyết',
  BuyerTime: 'Ngày mua hộp',
  SellTime: 'Ngày bán hộp',
  ReturnTime: 'Ngày hoàn trả',
  OperationTime: 'Ngày hoạt động',
  Prompt1: 'Vui lòng nhập số đơn hàng',
  Prompt2: 'Vui lòng nhập số container',
  QuantitySum: 'Tổng số container',
  AmountSum: 'Tổng số tiền',
  Quantity2: 'Số lượng',
  BuyTime: 'Ngày mua',
  SellerDate: 'Ngày bán',
  RentDate: 'Ngày bắt đầu thuê',
  StartRentDate: 'Ngày bắt đầu thuê',
  ReturnDate: 'Ngày kết thúc',
  UnitRate: 'Đơn giá',
  ContainerNo: 'Số container',
  CurrencyCode: 'Loại tiền tệ',
  EQSize: 'Kiểu container',
  EQType: 'Chủng loại container',
  EQQuantity: 'Số container',
  Add: 'Thêm mới',
  Confirm: 'Xác nhận',
  Cancel: 'Hủy bỏ',
  Operation: 'Thao tác',
  UnitRate2: 'Đơn giá (NDT/ngày)',
  UnitRate3: 'NDT/ngày',
  ReturnBoxDate: 'Thời gian trả container',
  Term: 'Thời hạn',
  Day: 'Ngày',
  UnitPriceInterval: 'Khoảng đơn giá',
  BuyBoxTotalTankVolume: 'Tổng số container mua',
  TotalCost: 'Tổng chi phí',
  SellOutTotalTankVolume: 'Tổng số container bán',
  TotalSalesAmount: 'Tổng số tiền bán',
  CostUnitPrice: 'Đơn giá chi phí',
  CostUnitPriceCurrencyCode: 'Loại tiền tệ đơn giá chi phí',
  SellingUnitPrice: 'Đơn giá bán',
  SellingUnitPriceCurrencyCode: 'Loại tiền tệ đơn giá bán',
  ETDNotNull: 'Ngày gửi hàng không được để trống',
  ETANotNull: 'Ngày đến không được để trống',
  PaymentMethodCannotBlank: 'Phương thức thanh toán không được để trống',
  DepartureStationCannotEmpty: 'Ga xuất phát không được để trống',
  TransferStationCannotEmpty: 'Trạm trung chuyển không được để trống',
  TransitStationCannotEmpty: 'Trạm quá cảnh không được để trống',
  DestinationStationCannotEmpty: 'Trạm đích không được để trống',
  CharacterLengthTooLongMaintainAgain: 'Độ dài ký tự vượt quá giới hạn, vui lòng điều chỉnh lại!',
  TheNotOnTheBustrain: 'Chứng từ được chọn không thuộc cùng chuyến xe/chuyến tàu',
  OperationFailed: 'Thao tác thất bại',
  SelectTime: 'Chọn thời gian',
  BulkModifyDestinationPortInformation: 'Sửa đổi hàng loạt thông tin cảng đích',
  NonWarehouseOverseasTransferWarehouse: 'Kho trung chuyển hải ngoại không phải kho Amazon',
  EstimatedDeliveryTime: 'Thời gian dự kiến giao hàng',
  ActualDeliveryTime: 'Thời gian giao hàng thực tế',
  DomesticWarehouse: 'Kho nội địa',
  OverseasWarehouse: 'Kho nước ngoài',
  WithCostRefundForClearing: '(Có phí hủy thông quan)',
  TheExpiresAndNoCreated: 'Hợp đồng của đơn vị ủy thác đã hết hạn, không thể tạo nghiệp vụ mới',
  DueNotBePrintedNeeded: 'Do vượt quá hạn mức tín dụng, vận đơn này đã bị khóa, không thể in hoặc gửi EDI. Vui lòng liên hệ cấp trên để mở khóa khi cần!',
  LockedPleaseContactTheUnlock: 'Đã bị khóa, không thể in. Vui lòng liên hệ quản lý cấp trên để mở khóa!',
  FCLProfitPrint: 'In báo cáo lợi nhuận FCL',
  AttachmentContentTooLarge: 'Nội dung tệp đính kèm quá lớn',
  LCLProfitPrint: 'In báo cáo lợi nhuận LCL',
  ContainerType2: 'Loại container',
  AdjustmentOperation: 'Thao tác điều container',
  All: 'Tất cả',
  Days: 'Ngày',
  ExpectedToEnterAmazonWarehouse: 'Thời gian dự kiến nhập kho Amazon',
  ReferenceContainerNumber: 'Số container tham chiếu',
  Export: 'Xuất khẩu',
  Import: 'Nhập khẩu',
  ReturnContainer: 'Trả container',
  PleaseEnterContainerInformation: 'Vui lòng nhập thông tin container!',
  PleaseEnterReturnContainerTime: 'Vui lòng nhập thời gian trả container!',
  ReturnSuccessfulSuccessfulReturnCount: 'Thao tác trả container thành công! Số container đã trả:',
  NumberOfContainerPieces: 'Số kiện container:',
  GreaterActualNumberOfPieces: 'Lớn hơn số kiện thực tế:',
  ContainerWeight: 'Trọng lượng container:',
  GreaterThanTheActualWeight: 'Lớn hơn trọng lượng thực tế:',
  ContainerVolume: 'Thể tích container:',
  GreaterThanTheActualVolume: 'Lớn hơn thể tích thực tế:',
  JobNumber: 'Số công việc:',
  ServiceChannel: 'Kênh dịch vụ',
  PostalCode: 'Mã bưu điện',
  DestinationDeliveryMethod: 'Phương thức giao hàng tại đích',
  ExpressCompany: 'Công ty chuyển phát',
  TrackingNumber: 'Số vận đơn',
  POoriginalOrderNumber: 'PO (số đơn gốc)',
  CustomsDeclarationMethod: 'Phương thức khai báo hải quan',
  CustomsClearanceMethod: 'Phương thức thông quan',
  EORIEnterpriseNumber: 'Số EORI doanh nghiệp',
  VATtaxNumber: 'VAT/mã số thuế',
  VATRegistrationCountry: 'Quốc gia đăng ký VAT',
  VATRegistrationAddress: 'Địa chỉ đăng ký VAT',
  VATCompanyEnglishName: 'Tên tiếng Anh công ty VAT',
  WithBattery: 'Có pin',
  WithMagnet: 'Có từ tính',
  Powder: 'Bột',
  Liquid: 'Chất lỏng',
  EstimatedStoragegoodsReadyTime: 'Thời gian dự kiến nhập kho/hàng sẵn sàng',
  RemoteWarehouse: 'Kho vùng sâu vùng xa',
  ThisHasExpiredCannotBusiness: 'Hợp đồng của đơn vị ủy thác đã hết hạn, không thể tạo nghiệp vụ mới',
  Freight: 'Cước vận chuyển',
  ServiceChannel2: 'Kênh dịch vụ:',
  CostType: 'Loại phí:',
  EstimatedAmount: 'Số tiền ước tính:',
  EquivalentTo: 'Quy đổi',
  FareLevel: 'Cước vận chuyển:',
  BillingWeight: 'Trọng lượng tính cước:',
  CalculationMethod: 'Phương thức tính toán:',
  TheTypeCannotBeEmpty: 'Loại ủy thác không được để trống',
  TransportTypeCannotBeEmpty: 'Loại vận chuyển không được để trống',
  FullJourneyCannotBeEmpty: 'Toàn trình/bán trình không được để trống',
  ShippingRouteCannotBeEmpty: 'Tuyến đường không được để trống',
  DepartureBeLaterThanDate: 'Ngày phát hàng không được muộn hơn ngày đến',
  DepartureStationCannotBeEmpty: 'Ga đi không được để trống',
  TransitStationCannotBeEmpty: 'Ga trung chuyển không được để trống',
  TransitStationCannotBeEmpty2: 'Ga quá cảnh không được để trống',
  DestinationStationCannotBeEmpty: 'Ga đến không được để trống',
  PaymentMethodCannotBeEmpty: 'Phương thức thanh toán không được để trống',
  SalesCannotBeEmpty: 'Nhân viên bán hàng không được để trống',
  OperationCannotBeEmpty: 'Thao tác không được để trống',
  AlreadyOtherBoxTypesTime: 'Đã chọn [toa mở/toa có mái che/toa phẳng], không thể chọn loại container khác ngoài ba loại này!',
  EstimatedTimeCannotBeEmpty: 'Thời gian dự kiến nhập kho/hàng sẵn sàng không được để trống!',
  DestinationCannotBeEmpty: 'Điểm đến không được để trống!',
  DestinationCountryCannotBeEmpty: 'Quốc gia đến không được để trống!',
  ZipCodeCannotBeEmpty: 'Mã bưu điện không được để trống!',
  CannotBeEmpty: 'Không được để trống!',
  PleaseTheEntrustingUnitFirst: 'Vui lòng chọn đơn vị ủy thác trước.',
  EstimatedStoragegoodReadyTime: 'Thời gian dự kiến nhập kho/hàng sẵn sàng',
  NoTicketChecked: 'Chưa chọn hóa đơn nhỏ',
  CustomersOwnContainer: 'Container tự chuẩn bị của khách hàng',
  CompanyOwnedContainer: 'Container sở hữu công ty',
  RentalContainer: 'Container thuê ngoài',
  ContainerUsageImportTemplateRailwayXls: 'ContainerUsageImportTemplate(Đường sắt).xls',
  CurrentBeenSubmittedCannotOperate: 'Nghiệp vụ hiện tại đã được gửi, không thể thao tác!',
  AreWantToPerformOperation: 'Xác nhận thực hiện thao tác này?',
  CostNotConfiguredPleaseCheck: 'Loại phí chưa được cấu hình, vui lòng kiểm tra!',
  CostAuditedOrInvoicedCheck: 'Phí đã được duyệt hoặc đã xuất hóa đơn, vui lòng kiểm tra!',
  CleaningCompletedSuccessfulCleaningNumber: 'Dọn dẹp hoàn tất! Số lượng dọn dẹp thành công:',
  PleaseBoxesYouWantProcess: 'Vui lòng chọn container cần xử lý!',
  ContainsContainerDataPleaseCheck: 'Bao gồm dữ liệu chưa điều container, vui lòng kiểm tra!',
  PleaseSelectAContainer: 'Vui lòng chọn một container',
  FirstLeglastLeg: 'Chặng đầu/chặng cuối',
  TransportationMethod: 'Phương thức vận chuyển',
  ContactPerson: 'Người liên hệ',
  DetailedAddress: 'Địa chỉ chi tiết',
  FirstLeglastLegInformation: 'Thông tin chặng đầu/chặng cuối',
  CustomerDoordestinationPortDoor: 'Điểm giao nhận khách hàng/cảng đích',
  CustomerContactPerson: 'Người liên hệ khách hàng',
  FirstLegCannotBeEmpty: 'Chặng đầu/chặng cuối không được để trống',
  PleaseEnterTransportationCompanyInformation: 'Vui lòng nhập thông tin công ty vận chuyển',
  PleaseSelectDesignatedData: 'Vui lòng chọn dữ liệu chỉ định',
  PleaseSelectTradeInformation: 'Vui lòng chọn thông tin thương mại.',
  RailwayOperationGoodsDetails: 'Chi tiết hàng hóa thao tác đường sắt',
  SellingContainer: 'Bán container',
  TotalPurchaseContainer: 'Tổng số container mua',
  TotalCostAmount: 'Tổng chi phí',
  TotalSoldContainer: 'Tổng số container bán',
  TotalSellingAmount: 'Tổng doanh thu bán',
  ModificationSuccessful: 'Sửa đổi thành công',
  BuyingContainer: 'Mua container',
  Yes: 'Có',
  No: 'Không',
  PleaseTheContainerToEdit: 'Vui lòng chọn container cần chỉnh sửa!',
  EditOrderInformation: 'Chỉnh sửa thông tin đơn hàng',
  PleaseTheContainerToDelete: 'Vui lòng chọn container cần xóa!',
  AreWantToDeleteInformation: 'Xác nhận xóa thông tin container này?',
  PromptInformation: 'Thông báo',
  DeletingOrderContainsOccupiedContainers: 'Đơn hàng xóa có container đang được sử dụng!',
  CurrentlySelected: '(Lựa chọn hiện tại)',
  CurrentPage: '(Trang hiện tại)',
  CurrentlyAvailable: 'Hiện có sẵn',
  CurrentlyOccupied: 'Đang sử dụng',
  Sold: 'Đã bán',
  ContainerInquiry: 'Tra cứu container',
  BoxReturnedCannotContinueOperate: 'Container số: {0} đã trả, không thể tiếp tục thao tác!'
}

